import axios from 'axios';

class IsRead
{
    constructor ()
    {


        this.target = document.querySelector( '#read-target' );

        if ( !this.target )
        {
            this.target = document.querySelector( '#footer' );
        }


        // console.log( 'this.target  final target =', this.target );

        this.sentSeen = false;

        // if ( typeof AsGlobalSettings === 'undefined'
        //     || typeof AsGlobalSettings.isAuthenticated === 'undefined'
        //     || !AsGlobalSettings.isAuthenticated )
        // {
        //     // not logged in, nothing to measure
        //     return;
        // }

        if (this.target)
        {
            this.setupDetection();
        }
    }

    setupDetection ()
    {

        // console.log( 'Setting up detection' );

        this.observer;

        let options = {
            root       : null,
            rootMargin : "0px",
            threshold  : 0.9,
        };

        if (typeof IntersectionObserver === 'function' && this.target)
        {
            this.observer = new IntersectionObserver(this.handleIntersect.bind(this), options);

            this.observer.observe(this.target);
        }
    }

    handleIntersect ( entries, observer )
    {
        entries.forEach( ( entry ) =>
        {
            if ( entry.intersectionRatio > 0.6 )
            {

                setTimeout( () => this.sendSeen(), 5000);


                // no need to keep checking
                if (this.observer && this.target)
                {
                    this.observer.unobserve(this.target);
                }
            }
        } );
    }


    async sendSeen ()
    {


        const postType = AsGlobalSettings?.postType ?? '';
        const postId   = AsGlobalSettings?.postId ?? 0;


        try
        {

            if ( typeof AsGlobalSettings !== 'undefined'
                 && AsGlobalSettings.isAuthenticated )
            {
                let response = await axios.post(`/endpoints/logseen`, {
                    postType: postType,
                    postId:   postId,
                });
            }


            let track = await axios.post(`/endpoints/track/view/${postType}/${postId}`)

            // console.log( '[IsRead] Sent page view  for postType = ' + postType + '  with an ID of ' + postId + '. The reponse was ', response );
        }
        catch (e)
        {
            console.error( '[IsRead] Tried logging a view, but something went wrong', e );
        }

    }
}

const isRead = new IsRead();
